export default __webpack_public_path__ + "static/media/image-home-banner-caro1.96017617.svg";